import { supabaseClient } from '../supabase'

const sendMail = async (data, recipient = null) => {
  const inProduction = process.env.NODE_ENV === 'production'

  if ( ! data?.identity ) return false

  const payload = {
    profile_id: data?.identity?.id,
    toEmail: recipient ?? data?.identity?.email,
    toName: data?.identity?.fullName ?? `${data?.identity?.first_name} ${data?.identity?.last_name}` ?? '',
    subject: data?.subject ?? 'Erreur FormaContacts',
    textPart: data?.messageTEXT ?? `Une erreur FormaContacts vient de se produire pour l'utilisateur ${data?.identity.email}`,
    htmlPart: data?.messageHTML ?? `<h3>Ooops...</h3><p>Une erreur FormaContacts vient de se produire pour l'utilisateur ${data?.identity.email}.</p>`,
    date: data?.date,
    send_now: data?.sendNow ?? true,
  }

  if ( !inProduction ) {
    console.log('Email sent successfully!')
    return true
  }

  const { error } = await supabaseClient
    .from('send_mail')
    .upsert([payload])

  if (error) {
    console.error('Impossible d\'envoyer un mail:', error.message)
    return false
  }

  return true
}

export default sendMail